import styled from 'styled-components'

export const CFlatListSection = styled.div`
	width: 100%;
	height: 100%;
	flex-direction: row;
	align-items: center;
	justify-content: center;
`
